import { DateTime } from 'luxon'

export function formatDateTime(
  dt: DateTime,
  options?: { weekday?: boolean; now?: DateTime }
): string {
  const reference = options?.now ?? DateTime.now()
  const sameYear = dt.year === reference.year
  if (options?.weekday) {
    return sameYear
      ? dt.toFormat('ccc, LLL d, h:mm a')
      : dt.toFormat('ccc, LLL d, yyyy h:mm a')
  }
  return sameYear
    ? dt.toFormat('LLL d, h:mm a')
    : dt.toFormat('LLL d, yyyy h:mm a')
}

export function formatDurationHuman(from: DateTime, to: DateTime): string {
  const diffMs = to.toMillis() - from.toMillis()
  const hours = Math.round(diffMs / 3_600_000)
  if (hours >= 48) {
    const days = Math.round(hours / 24)
    return `${days} days`
  }
  if (hours >= 1) {
    return hours === 1 ? '1 hour' : `${hours} hours`
  }
  const minutes = Math.max(1, Math.round(diffMs / 60_000))
  return minutes === 1 ? '1 minute' : `${minutes} minutes`
}

export const formatRelativeTime = (date: Date) => {
  const now = DateTime.local()
  const then = DateTime.fromJSDate(date)
  const diff = now.diff(then, ['months', 'days', 'hours', 'minutes', 'seconds'])

  if (diff.months > 0) {
    return then.toLocaleString(DateTime.DATE_MED)
  }
  if (diff.days > 0) {
    return `${Math.floor(diff.days)} day${diff.days > 1 ? 's' : ''} ago`
  }
  if (diff.hours > 0) {
    return `${Math.floor(diff.hours)} hour${diff.hours > 1 ? 's' : ''} ago`
  }
  if (diff.minutes > 0) {
    return `${Math.floor(diff.minutes)} minute${
      diff.minutes > 1 ? 's' : ''
    } ago`
  }
  return 'Just now'
}

export const formatDate = (d?: Date | null) => {
  if (!d) return null
  const dt = DateTime.fromJSDate(d)
  return `${dt.toLocaleString(DateTime.DATE_MED)}`
}
